import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { TextArea } from '../../../components/items/joinInput';
import { AlertModal } from '../../../components/modal/alert.modal';
import { ConfirmModal } from '../../../components/modal/confirm.modal';
import { fetchAdminRegistNotice } from '../../../api/admin.notice';

interface CreateNoticeDtoTx {
  title: string;
  content: string;
}

const AdminNoticeRegist = () => {
  const [formData, setFormData] = useState<CreateNoticeDtoTx | null>(null);
  const { register, handleSubmit } = useForm<CreateNoticeDtoTx>();

  // 모달
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [confirmModal, setConfirmModal] = useState(false);
  const [navigateOnClose, setNavigateOnClose] = useState(false); // 페이지 이동 여부를 추적

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (navigateOnClose) {
      history.push({
        pathname: '/admin/notice/list',
      });
    }
  };

  const handleConfirmClose = () => {
    setConfirmModal(false);
  };

  //답변 등록 핸들러
  const handleAnswerRegist = async (data: CreateNoticeDtoTx) => {
    try {
      const response = await fetchAdminRegistNotice(data);
      if (response.statusCode === 200) {
        setModalMessage('공지사항이 성공적으로 등록되었습니다.');
        setIsModalOpen(true);
        setNavigateOnClose(true);
      } else {
        setModalMessage('공지사항 등록에 실패했습니다.');
        setIsModalOpen(true);
        setNavigateOnClose(false);
      }
    } catch (error) {
      console.error(error);
      setModalMessage('공지사항 등록 중 오류가 발생했습니다.');
      setIsModalOpen(true);
    }
  };

  // 폼 제출 시 실행될 함수
  const onSubmit = (data: { title: string; content: string }) => {
    if (data.title.length === 0) {
      setModalMessage('제목은 필수입니다.');
      setIsModalOpen(true);
      return;
    }
    if (data.content.length === 0) {
      setModalMessage('내용은 필수입니다.');
      setIsModalOpen(true);
      return;
    }

    const formData: CreateNoticeDtoTx = {
      title: data.title,
      content: data.content,
    };
    setFormData(formData);
    setConfirmModal(true);
  };

  const cancleHandle = () => {
    history.push('/admin/notice/list');
  };

  const handleConfirmAction = () => {
    setConfirmModal(false);
    console.log(formData);
    if (formData) {
      handleAnswerRegist(formData);
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="inner">
          <div className="title">공지사항 등록</div>
          <div className="detail-info-wrap">
            <ul>
              <li>
                <span>제목</span>
                <div className="input-box">
                  <input
                    type="text"
                    {...register('title')}
                    placeholder="제목을 입력하세요."
                  />
                </div>
              </li>
              <li className="content">
                <span>내용</span>
                <div className="box">
                  <TextArea
                    name="content"
                    register={register}
                    placeholder="답변을 입력해주세요."
                  />
                </div>
              </li>
            </ul>
          </div>
          <div className="btn-box">
            <button className="cancle" onClick={cancleHandle}>
              취소
            </button>
            <button className="regist" type="submit">
              등록
            </button>
          </div>
        </div>
      </form>

      {confirmModal && (
        <ConfirmModal
          handleConfirmClose={handleConfirmClose}
          confirmText={'등록하시겠습니까?'}
          onClick={handleConfirmAction} // 확인 시 handleConfirmAction 호출
        />
      )}

      {isModalOpen && (
        <AlertModal
          handleConfirmClose={handleModalClose}
          confirmText={modalMessage}
          onClick={handleModalClose}
        />
      )}
    </Container>
  );
};

export default AdminNoticeRegist;

// style
const Container = styled.div`
  margin-top: 7rem;
  overflow-y: scroll;
  .inner {
    max-width: 70rem;
    width: 100%;
    margin: 0 auto;
    .title {
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 2.4rem;
    }
    .detail-info-wrap {
      ul {
        border-top: 2px solid #000;
        border-bottom: 2px solid #000;
        li {
          display: flex;
          align-items: center;
          padding: 0 0.8rem;
          span {
            display: inline-flex;
            width: 9.6rem;
            font-size: 1.4rem;
            font-weight: 600;
            color: #222;
          }
          p {
            display: inline-flex;
            font-size: 1.4rem;
            color: #555;
            &.no-info {
              color: #000;
            }
          }
          .input-box {
            width: 100%;
            padding: 0.6rem 0;
            input[type='text'] {
              display: flex;
              width: 100%;
              min-height: 4.2rem;
              padding: 1.4rem 1.8rem;
              border: 1px solid #d6dbe1;
              border-radius: 0.8rem;
              resize: vertical;
              font-size: 1.4rem;
              font-weight: 400;
              resize: none;
              &::placeholder {
                color: ${(props) => props.theme.searchPlaceholderColor};
              }
            }
          }
          &:not(:last-child) {
            border-bottom: 1px solid #eee;
          }
          &.content {
            height: 43.9rem;
            align-items: flex-start;
            padding: 1rem;

            .box {
              width: 100%;
              textarea {
                height: 41.3rem;
              }
            }
          }
        }
      }
    }
    .btn-box {
      margin-top: 2.4rem;
      display: flex;
      justify-content: center;
      margin-bottom: 4rem;
      gap: 0.8rem;
      button {
        padding: 1.1rem 1rem;
        white-space: nowrap;
        border: none;
        outline: none;
        border-radius: 0.8rem;
        font-size: 1.5rem;
        width: 10rem;
        &.cancle {
        }
        &.regist {
          background-color: ${(props) => props.theme.btnBlueColor};
          color: ${(props) => props.theme.textWhiteColor};
        }
      }
    }
  }
`;
